import { ADD_AREA, UPDATE_AREA, GET_AREA, GET_AREA_BY_ID, DELETE_AREA } from '../types';

const initialState = {
   list: [],
   single: null,
   loading: false,
};

const areaReducer = (state = initialState, action) => {
   switch (action.type) {
      case ADD_AREA:
         return {
            ...state,
            list: [action.payload, ...state.list],
         };
      case UPDATE_AREA:
         return {
            ...state,
            list: state.list.map((item) => (item.id === action.payload.id ? action.payload : item)),
         };
      case GET_AREA:
         return {
            ...state,
            list: action.payload,
         };
      case GET_AREA_BY_ID:
         return {
            ...state,
            single: action.payload,
         };
      case DELETE_AREA:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== action.payload.id),
         };
      default:
         return state;
   }
};
export default areaReducer;
